// extracted by mini-css-extract-plugin
export default {"btn":"PanelAssignButton_btn__aMlyt","btnIcon":"PanelAssignButton_btnIcon__8ICPh","btnText":"PanelAssignButton_btnText__iMrTM"};